import React from "react";
import "./Footer.css";
import Wave from "../../img/wave.png";
import Insta from "@iconscout/react-unicons/icons/uil-instagram";
import Facebook from "@iconscout/react-unicons/icons/uil-facebook";
import Youtube from "@iconscout/react-unicons/icons/uil-youtube";
import Linkedin from "@iconscout/react-unicons/icons/uil-linkedin";

const Footer = () => {
  return (
    <div style={{marginTop:"3rem"}} className="footer">
      <img src={Wave} alt="" style={{ width: "100%" }} />
      <div className="f-content">
        <span className="">esisa-analytica@gmail.com</span>
        <div className="f-icons">
         
          <a href="https://www.linkedin.com/company/esisa-analytica/" target="_blank" rel="noopener noreferrer">
            <Linkedin color="white" size={"3rem"} />
          </a>
        </div>
      </div>
    </div>
  );
};

export default Footer;
